import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_handmade_jewelry: FaireThemeEntity = {
  token: "discovery_theme_handmade-jewelry",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Handmade Jewelry",
  description: "Artisan pieces crafted with care",
  bgColor: "#F0D8E8",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
